import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Briefcase, MapPin, Calendar, Banknote, ExternalLink, Users } from "lucide-react";
import SEO from "@/components/SEO";

export default function JobCircularDetails() {
    const { id } = useParams();
    const { t, lang } = useI18n();
    const [j, setJ] = useState(null);
    useEffect(() => { api.get(`/job-circulars/${id}`).then((r) => setJ(r.data)); }, [id]);
    if (!j) return <div className="text-center py-20">Loading...</div>;
    return (
        <>
            <SEO title={j.title} description={`${j.organization} - ${j.title}`} />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="text-xs font-bold uppercase tracking-wider text-brand-red">{j.category}</div>
            <h1 className="text-3xl md:text-4xl font-bold text-brand-navy mt-2">{j.title}</h1>
            <div className="text-brand-navy/65 mt-1 text-lg">{j.organization}</div>

            <div className="grid sm:grid-cols-4 gap-3 mt-6">
                <Stat icon={Calendar} label={t("deadline")} value={j.deadline} />
                <Stat icon={MapPin} label={t("location")} value={j.location} />
                <Stat icon={Banknote} label={t("salary")} value={j.salary} />
                <Stat icon={Users} label={t("vacancy")} value={j.vacancy} />
            </div>

            <div className="mt-8 prose prose-slate max-w-none whitespace-pre-line text-brand-navy/80 leading-relaxed">
                {j.description}
            </div>

            <a href={j.apply_url || "#"} target="_blank" rel="noreferrer" className="btn-accent mt-10 inline-flex items-center gap-2 px-7 py-3.5 rounded-xl font-semibold" data-testid="apply-btn">
                {t("apply_now")} <ExternalLink className="w-4 h-4" />
            </a>
        </div>
        </>
    );
}

function Stat({ icon: Icon, label, value }) {
    return (
        <div className="bg-white border border-brand-light rounded-xl p-4">
            <div className="flex items-center gap-2 text-xs text-brand-navy/60"><Icon className="w-3.5 h-3.5 text-brand-royal" /> {label}</div>
            <div className="font-semibold text-brand-navy mt-1">{value}</div>
        </div>
    );
}
